import { errors } from './errors'
import { authPage } from './authPage'
import { buttons } from './buttons'
import { cartPage } from './cartPage'
import { errorPages } from './errorPages'
import { explorePage } from './explorePage'
import { faqPage } from './faqPage'
import { feedPage } from './feedPage'
import { footer } from './footer'
import { gamesPage } from './gamesPage'
import { goldPlans } from './goldPlans'
import { header } from './header'
import { myToysPage } from './myToysPage'
import { paymentsPage } from './paymentsPage'
import { postPage } from './postPage'
import { privacyPage } from './privacyPage'
import { publicProfile } from './publicProfile'
import { sellToyPage } from './sellToyPage'
import { settingsPage } from './settingsPage'
import { sorting } from './sorting'
import { termsOfUsePage } from './termsOfUsePage'
import { toyPage } from './toyPage'
import { toys } from './toys'
import { ui } from './ui'
import { withdrawPage } from './withdrawPage'
import { createToy } from './createToy'
import { collectionsPage } from './collectionsPage'
import { artistsPage } from './artistsPage'
import { paymentHistoryPage } from './paymentHistoryPage'
import { drops } from './drops'
import { referralAwards } from './referralAwards'
import { profilePage } from './profilePage'
import { collectionPage } from './collectionPage'
import { news } from './news'
import { quiz } from './quiz'
import { block } from './block'
import { report } from './report'

export type enType = keyof typeof en

const en = {
    ...quiz,
    ...ui,
    ...header,
    ...footer,
    ...feedPage,
    ...explorePage,
    ...myToysPage,
    ...cartPage,
    ...paymentsPage,
    ...sellToyPage,
    ...withdrawPage,
    ...collectionPage,
    ...postPage,
    ...gamesPage,
    ...settingsPage,
    ...errorPages,
    ...authPage,
    ...news,
    ...toyPage,
    ...profilePage,
    ...sorting,
    ...goldPlans,
    ...errors,
    ...buttons,
    ...toys,
    ...publicProfile,
    ...privacyPage,
    ...termsOfUsePage,
    ...faqPage,
    ...createToy,
    ...collectionsPage,
    ...artistsPage,
    ...paymentHistoryPage,
    ...drops,
    ...referralAwards,
    ...block,
    ...report,
}

export default en
